<template>
  <div>
    <ExtEnvComponent></ExtEnvComponent>
    <CRow>
      <CCol col="12">
        <CCard>
          <CCardBody class="p-2">
            <CForm inline>
              <label
                class="col-form-label ml-2 mr-2"
                style="min-width: 55px; display: block"
                >검색조건</label
              >
              <CSelect
                :value.sync="inFacilityId"
                :options="inFacilityList"
                style="margin-bottom: 0; width: 97%"
                class="ml-2 ml-sm-0 w-auto-sm"
              >
              </CSelect>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol col="12">
        <CCard>
          <CCardBody class="p-2">
            <CTabs :active-tab.sync="tab">
              <CTab title="VPD/HD" active>
                <div class="p-2">
                  <div class="row">
                    <div class="col-lg-8">
                      <MollierDiagramComponent
                        :properties="mollierDiagram"
                      ></MollierDiagramComponent>
                    </div>
                    <div class="col-lg-4">
                      <RealTimeVpdHdComponent
                        :properties="realTimeVpdHd"
                      ></RealTimeVpdHdComponent>
                    </div>
                  </div>
                </div>
              </CTab>
              <CTab title="포화수증기량">
                <div class="p-2">
                  <div class="row">
                    <div class="col-lg-8">
                      <SaturatedWaterVaporComponent></SaturatedWaterVaporComponent>
                    </div>
                    <div class="col-lg-4">
                      <RealTimeSaturatedWaterVaporComponent></RealTimeSaturatedWaterVaporComponent>
                    </div>
                  </div>
                </div>
              </CTab>
              <CTab title="상대습도">
                <div class="p-2">
                  <div class="row">
                    <div class="col-lg-8">
                      <RelativeHumidityComponent :properties="relativeHumidity"></RelativeHumidityComponent>
                    </div>
                    <div class="col-lg-4">
                      <RealTimeRelativeHumidityComponent></RealTimeRelativeHumidityComponent>
                    </div>
                  </div>
                </div>
              </CTab>
            </CTabs>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import ExtEnvComponent from "@/components/monitoring/ExtEnvComponent";
import store from "@/store";
import core from "@/core";
import SensorService from "@/services/sensor/sensor.service";
import MollierDiagramComponent from "@/components/analysis/MollierDiagramComponent";
import RealTimeVpdHdComponent from "@/components/analysis/RealTimeVpdHdComponent";
import SaturatedWaterVaporComponent from "@/components/analysis/SaturatedWaterVaporComponent";
import RealTimeSaturatedWaterVaporComponent from "@/components/analysis/RealTimeSaturatedWaterVaporComponent";
import RelativeHumidityComponent from "@/components/analysis/RelativeHumidityComponent";
import RealTimeRelativeHumidityComponent from "@/components/analysis/RealTimeRelativeHumidityComponent";
import MixinsInFacility from "@/mixins/in-facility";

export default {
  name: "EnvVpdHd",
  components: {
    RealTimeRelativeHumidityComponent,
    RelativeHumidityComponent,
    RealTimeSaturatedWaterVaporComponent,
    SaturatedWaterVaporComponent,
    RealTimeVpdHdComponent,
    MollierDiagramComponent,
    ExtEnvComponent,
  },
  mixins: [MixinsInFacility()],
  data() {
    return {
      tab: 0,
      mollierDiagram: {
        initFlag: false,
        inEnvList: [],
      },
      realTimeVpdHd: {
        initFlag: false,
        inEnvList: [],
      },
      relativeHumidity: {
        initFlag: false,
        inEnvList: [],
      },
      inEnv: {
        requestMoment: null,
        list: [],
      },
    };
  },
  watch: {
    tab() {
      this.getSensorData();
    },
    inFacilityId(val) {
      console.log("changed inFacilityId");
      if (val != null) {
        this.inEnv.requestMoment = null;
        this.inEnv.list = [];

        this.mollierDiagram.initFlag = true;
        this.realTimeVpdHd.initFlag = true;
        this.relativeHumidity.initFlag = true;
        this.getSensorData();
      }
    },
  },
  methods: {
    onControl(key, item) {
      console.log(`onControl ${key}, `, item);
    },
    toggleControlButton(enableItemList) {
      const control = this.control;
      for (let key in control.op) {
        const item = control.op[key];
        item.disabled = true;
      }
      for (let key in control.dev) {
        const item = control.dev[key];
        item.disabled = true;
      }
      enableItemList.forEach((item) => {
        item.disabled = false;
      });
    },
    async getSensorData(option) {
      const inFacilityId = this.inFacilityId;
      if (inFacilityId == null) {
        return null;
      }

      const startMoment = core.date.instance();
      const endMoment = core.date.instance().add(1, "days");

      const inEnv = this.inEnv;
      let list = null;
      if (inEnv.requestMoment != null) {
        const elapsedTimeMillis =
          startMoment.toDate().getTime() -
          inEnv.requestMoment.toDate().getTime();
        if (elapsedTimeMillis < 60000) {
          list = inEnv.list;
        }
      }

      if (list == null) {
        inEnv.requestMoment = core.date.instance();
        list = inEnv.list = await SensorService.getInEnvList({
          inFacilityId: inFacilityId,
          sensingAtGreaterThanEqual: startMoment.format("YYYY-MM-DD"),
          sensingAtLessThan: endMoment.format("YYYY-MM-DD"),
        });
      }
      if (this.tab === 0) {
        // VPH/HD
        this.mollierDiagram.inEnvList = list;
        if (option !== "ignoreChart") {
          this.realTimeVpdHd.inEnvList = list;
        }
      } else if (this.tab === 1) {
      } else if (this.tab === 2) {
        this.relativeHumidity.inEnvList = list;
      } else {
        console.log("Unknown tab : ", this.tab);
        return;
      }
    },
  },
};
</script>
